var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agent-header"},[_c('TopBar'),_vm._v(" "),(!_vm.zoneHomePage)?_c('SearchBar'):_vm._e(),_vm._v(" "),_c('MenuBar',{attrs:{"zone-home-page":_vm.zoneHomePage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }